module.exports = __webpack_public_path__ + "static/collage-product-a8f698e80e05c16027d1b9e5bb437c8f.jpg";